import {
    buildExportFilename,
    downloadItemsAsCSV,
    downloadTimeSeriesAsCSV,
    getHierarchyCSVColumns,
} from 'utils/formatCSV';
import bugsnagClient from 'containers/BugsnagClient';
import { downloadTypes } from 'components/Button/DownloadCSVMenuButton';
import toast from 'react-hot-toast';

const typeFromPaginateBy = (paginateBy) =>
    paginateBy === 'brands'
        ? 'brand'
        : paginateBy === 'hashtags'
          ? 'hashtag'
          : 'trend';

export function getInstagramDownloadOptionsAsync({
    entity,
    country,
    date,
    visibleOrderedMetrics,
    paginateBy,
    getQueryData,
    isAdmin,
}) {
    const baseParams = {
        entity,
        country,
        source: 'instagram',
        type: typeFromPaginateBy(paginateBy),
        date,
    };
    return [
        {
            mixpanelMeta: { label: 'table data csv' },
            children: 'Table Data CSV',
            onClick: () => {
                toast.promise(
                    (async () => {
                        try {
                            const allData = await getQueryData();
                            downloadItemsAsCSV(
                                buildExportFilename({
                                    ...baseParams,
                                    kind: 'data',
                                }),
                                allData,
                                [
                                    { key: 'name' },
                                    ...visibleOrderedMetrics.map(
                                        ({
                                            key,
                                            tableHeadColumnLabel: label,
                                        }) => ({ key, label }),
                                    ),
                                    {
                                        key: 'cluster',
                                        label: 'Cluster',
                                        accessor: ({ cluster }) =>
                                            cluster
                                                ? cluster.replace(
                                                      'instagram ',
                                                      '',
                                                  )
                                                : cluster,
                                    },
                                    { key: 'healthStats' },
                                    ...(paginateBy === 'categories'
                                        ? getHierarchyCSVColumns(isAdmin)
                                        : []),
                                ],
                            );
                        } catch (error) {
                            console.error('Error downloading CSV:', error);
                            throw error;
                        }
                    })(),
                    {
                        loading: 'Preparing download...',
                        success: 'Download complete!',
                        error: 'Error downloading CSV',
                    },
                );
            },
            downloadType: downloadTypes.CSV,
            key: 'table data csv',
        },
        {
            mixpanelMeta: { label: 'time series csv' },
            children: 'Time Series CSV',
            onClick: () => {
                toast.promise(
                    (async () => {
                        try {
                            const sortedData = await getQueryData();
                            downloadTimeSeriesAsCSV(
                                buildExportFilename({
                                    ...baseParams,
                                    kind: 'time-series',
                                }),
                                sortedData.reduce(
                                    (acc, { name, timeSeries }) => {
                                        if (!(timeSeries && timeSeries.length))
                                            return acc;
                                        return acc.concat({ name, timeSeries });
                                    },
                                    [],
                                ),
                                {
                                    columns: [{ key: 'name' }],
                                    tsColumns: [
                                        { key: 'date' },
                                        { key: 'real_volume', label: 'likes' },
                                        { key: 'backfill', label: 'estimated' },
                                    ],
                                },
                            );
                        } catch (err) {
                            bugsnagClient.notify(err);
                            throw err;
                        }
                    })(),
                    {
                        loading: 'Preparing download...',
                        success: 'Download complete!',
                        error: 'Error downloading time series CSV',
                    },
                );
            },
            downloadType: downloadTypes.CSV,
            key: 'time series csv',
        },
    ];
}
